<template lang="html">

  <section class="text-legal pad-sec">
    <div class="container">

      <div class="block-legal">
        <h3 class="title title-36">COOKIE POLICY</h3>
        <p class="bold">Information in compliance with personal data protection regulations</p>
        <p class="bold">- What are cookies and what do we use them for?</p>
        <p>A cookie is a small data file that is stored in your browser every time you visit our website.</p>
        <p>La utilidad de las cookies es guardar el historial de su actividad en nuestra página web, de manera que, cuando la visite nuevamente, ésta pueda identificarle y configurar el contenido de la misma en base a sus hábitos de navegación, identidad y preferencias.</p>
        <p>Cookies are useful for keeping track of your activity on our website so that when you visit it again, it can identify you and set the content of your visit based on your browsing habits, identity and preferences.<br>A cookie is harmless, it does not contain any malware or malicious code (e.g. viruses, Trojans, worms, etc.) that could damage your terminal (computer, smartphone, tablet, etc.), but it does have some impact on your right to data protection, as it collects certain information concerning you (browsing habits, identity, preferences, etc.).</p>

        <p class="bold">What information does a cookie store?</p>
        <p>Cookies do not usually collect special categories of personal data (sensitive data). The data they store is of a technical nature, personal preferences, personalization of contents, etc.</p>

        <p class="bold">What kind of cookies are there?</p>
        <p>Generally speaking, there are five types of cookies:</p>
        <ul>
          <li> <p class="bold">Technical Cookies:</p> 
            <p>These are the most basic cookies. They allow the user to navigate through a web page, platform or application and use the different options or services available, such as, for example, controlling traffic and data communication, identifying the session, accessing restricted areas, remembering the items making up an order, processing the purchase of an order, requesting registration or participation in an event, using security elements during navigation, storing content for the dissemination of videos or sound or sharing content through social media.</p>
          </li>

          <li> <p class="bold"> Customization Cookies:</p> 
            <p>These are cookies that allow the user to access the service with certain general characteristics predefined according to a series of criteria in the user's terminal, such as the language, the type of browser used to access the service, the regional configuration from which the service is accessed, etc.</p>
          </li>

          <li> <p class="bold"> Analytical Cookies:</p>
            <p>These are cookies allowing the party responsible for them to monitor and analyse the behaviour of users on the websites they are linked to. The information collected through these cookies is used to measure the activity of the websites, application or platform, and for the preparation of browsing profiles for the users of these websites, applications and platforms, in order to introduce improvements based on the analysis of the data used by the users of the service.</p>
          </li>

          <li> <p class="bold"> Advertising Cookies:</p>
            <p>These cookies allow the most efficient management possible of the advertising spaces, if any, that the party responsible has included on a web page, application or platform from which he or she provides the requested service based on criteria such as the content published or the frequency with which advertisements are displayed.</p></li>

            <li> <p class="bold">Behavioral advertising cookies:</p> 
              <p>These cookies allow the most efficient management possible of the advertising spaces, if any, that the party responsible has included on a web page, application or platform from which the requested service is provided. These cookies store information on the behavior of users, obtained through the continuous observation of their browsing habits, thus enabling them to develop a specific profile in order to display advertising based on it.</p>
            </li>

          </ul>

          <p class="bold">What are own and third-party cookies?</p>


          <ul>
            <li>
             <p class="bold">Own cookies: </p>
             <p>Own cookies are those generated and managed by the party responsible for providing the service requested by the user.</p>
           </li>
           <li><p class="bold">Third Party Cookies: </p>
            <p>These are generated by entities other than the party responsible (external services or suppliers, such as Google).</p>
          </li>
        </ul>



        <p class="bold">What kind of cookies does our website store?</p>
        <p>The following is a list of the types of cookies stored on our website and their purpose:</p>

        <ul >
          <li class="no-disc">
            <p class="bold">- Type of cookie</p>
            <p>
              Third Party Cookies, Analytical Cookies: Google Analytics  
            </p>
          </li>
          <li class="no-disc">
            <p class="bold">- Purpose</p>
            <p>Monitoring and analysis of user behavior on the website. The information collected through this type of cookie is used to measure activity on websites, create browsing profiles for the users of these sites, applications and platforms, in order to make improvements based on the analysis of the data on how visitors use the service.
            </p>
          </li>
          <li class="no-disc">
            <p class="bold">
              - When and how it is stored
            </p>
            <p>
              The cookie records the user's activity in real time while browsing and the data is stored in Google Analytics' application.
            </p>
          </li>

        </ul>
        <p>The AJUSATH website also works with the Local Storage application.</p>
        <p class="bold">What can I do with cookies?</p>
        <p>Cookies can be deleted, accepted or blocked as you wish; for this you only need to set up your web browser accordingly.</p>
        <p>At any time, you can prevent the installation of cookies on your computer by using the corresponding option on your browser, but in this case we cannot guarantee the correct operation of the various features on our website.</p>
        <p>Below, we provide you with links to manage and block cookies depending on the browser you use:</p>
        <p >Internet Explorer: <u><a href="http://windows.microsoft.com/es-xl/internet-explorer/delete-manage-cookies#ie=ie-10">http://windows.microsoft.com/es-xl/internet-explorer/delete-manage-cookies#ie=ie-10</a></u></p>
        <p > FireFox: <u><a href="http://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we">http://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we</a></u></p>
        <p >Chrome: <u><a href="https://support.google.com/chrome/answer/95647?hl=es">https://support.google.com/chrome/answer/95647?hl=es</a></u></p>
        <p >Safari: <u><a href="https://www.apple.com/legal/privacy/es/cookies/">https://www.apple.com/legal/privacy/es/cookies/</a></u></p>
        You can also delete the cookies you have stored in your browser by going into the set-up options.


      </div>

    </div>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'politica-cookies',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
  }
</script>

<style scoped>
.politica-cookies {

}
ul li{
  list-style: disc;
  margin-left: 20px;
}
b{
  font-weight: bold;
}
li.no-disc{
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/components/views/politica-cookies-en.vue